module.exports = __webpack_public_path__ + "assets/retina_Angle15Detailed.526f81bfabe335a32168c1e6aaab7358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle15Detailed.png
// module id = 612
// module chunks = 0